import { crmRequest, request, getLocal } from '@meta-vue/util'
import { v4 } from 'uuid'
import { Ossupload } from 'truck-lib'
import { compact } from 'lodash'
import libTrack from '@/plugins/libTrack'
import { SYNCHRONIZE_DOCUMENT_TYPES } from '@/util/const.js'
import { LOCALE_STORE_KEY } from '../constant'

/**
 * 构建下拉选项
 * @param {object} obj 配置数据
 * @returns {array}
 */
export function makeOptions(obj) {
  return Object.entries(obj).map(([key, val]) => ({ label: val, value: /^\d+$/.test(key) ? +key : key }))
}

function cleanup(script) {
  if (script.parentNode) script.parentNode.removeChild(script)
  script.onload = null
  script.onerror = null
  script = null
}

/**
 * 动态加载脚本，加载完成后删除脚本
 * @param {*} url 要加载的script的url
 * @returns Promise 加载完成后resolve
 */
export function scriptLoad(url) {
  const target = document.getElementsByTagName('script')[0] || document.head

  const script = document.createElement('script')
  script.src = url
  script.defer = true
  target.parentNode.insertBefore(script, target)

  return new Promise((resolve, reject) => {
    script.onload = function() {
      resolve()
      cleanup(script)
    }
    script.onerror = function() {
      reject(new Error('script load failed'))
      cleanup(script)
    }
  })
}
export function getFileName(filename, filetype) {
  const extMatch = (filename || '').match(/\.(\w+)$/i)
  const extByType = (filetype || '').match(/\/(\w+)$/i)
  let ext = ''
  if (extMatch && extMatch[1]) {
    ext = extMatch[1]
  }
  if (!ext && extByType && extByType[1]) {
    ext = extByType[1]
  }
  return compact([v4(), ext]).join('.')
}

export function getAbsoluteByRelative(key, bizType = 'im-files-private') {
  let codeEnv = process.env.VUE_APP_STATUS
  if (codeEnv === 'qa') codeEnv = 'qa'
  if (codeEnv === 'prod') codeEnv = 'www'
  return crmRequest(`${location.protocol}//${codeEnv}.ymm56.com/ymm-file-app/fileUpload/get/file/absoluteUrl`, {
    method: 'post',
    data: { key, bizType },
    silent: true,
    getter: {
      data: 'model'
    }
  })
}

/**
 * 参考文档https://devstatic.ymm56.com/truck-lib-docs/ossupload/#%E7%AE%80%E4%BB%8B
 * @param file
 * @param bizType
 * @param notAbsolute
 * @param onUploadProgress
 * @returns {Promise<{[p: string]: *}>}
 */
export async function fileOssUpload(file, { bizType = 'im-files-private', notAbsolute, onUploadProgress } = {}) {
  let codeEnv = process.env.VUE_APP_STATUS
  if (codeEnv === 'qa') codeEnv = 'beta'
  if (codeEnv === 'prod') codeEnv = 'production'

  console.log(
    file,
    { bizType, notAbsolute, onUploadProgress },
    '------fileOssUpload---------',
    getFileName(file.name, file.type)
  )

  // handlePreUploadInWeb(file)

  const url = await Ossupload.ossUpload({
    codeEnv: codeEnv, // OSS 存储环境, dev/beta/production
    bizType: bizType, // OSS 存储业务类型, 根据业务咨询后端
    file: file,
    fileName: getFileName(file.name, file.type),
    onUploadProgress: progressEvent => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      // 对原生进度事件的处理
      onUploadProgress && onUploadProgress(percent, progressEvent)
    }
  })

  const key = getUrlKey(url)
  if (notAbsolute) return { url, key }
  return {
    key: key,
    url: url,
    absoluteUrl: await getAbsoluteByRelative(key, bizType)
  }
}
function getUrlKey(url) {
  try {
    const urlParams = new URL(url)
    return urlParams.pathname
  } catch (e) {
    libTrack?.error?.(
      '上传图片解析key失败' + e?.message,
      {
        url
      },
      '上传图片解析key失败'
    )
    console.error('上传图片解析key失败', e)
    return url
  }
}

/**
 * 更新url地址
 * @param url
 * @returns {Promise<*|string>}
 */
export async function updateOssUrl(url) {
  if (typeof url !== 'string') return url
  try {
    const parsedUrl = new URL(url)
    const key = parsedUrl.pathname
    const regex = /\/ymmfile\/([a-zA-Z0-9-_]+)\//
    const match = url.match(regex)
    const bizType = match?.[1] // 这将是匹配到的 'user-pri'
    const newUrl = await getAbsoluteByRelative(key, bizType)
    return newUrl || url
  } catch (e) {
    console.warn(e)
    return url
  }
}

/**
 * 轮询节流方案
 * @param fn
 * @param delay
 * @param opt
 * @returns {{clear(): void}}
 */
export function setPolling(
  fn,
  delay = 1000,
  opt = {
    ignoreBackgrounder: false,
    ignoreOffline: true,
    from: ''
  }
) {
  const options = { ignoreBackgrounder: false, ignoreOffline: true, ...(opt || {}) }
  console.log('【setPolling】start', options?.from)
  let timer = null
  async function inside() {
    // console.log('【setPolling】inside', options?.from, timer)
    clearTimeout(timer)
    timer = setTimeout(inside, delay)
    try {
      let allow = true
      if (options?.ignoreBackgrounder && document.visibilityState === 'hidden') {
        console.log('后台轮循不加载')
        allow = false
      }
      if (options?.ignoreOffline && !window.navigator.onLine) {
        console.log('断网轮循不加载')
        allow = false
      }
      allow && (await fn())
    } catch (e) {
      console.warn(e)
    }
  }
  timer = setTimeout(inside, delay)
  // let polling = setAwaitTimeout(fn, 1000); polling.clear()可清除轮询
  return {
    clear() {
      console.log('【setPolling】clear', options?.from, timer)
      clearTimeout(timer)
      timer = null
    }
  }
}

// 弱依赖安全函数回调
export function safeCallback(fn) {
  try {
    return fn?.()
  } catch (e) {
    console.error('【safeCallback】', e)
  }
}

/**
 * 寻找子集vue组件集合
 * @param vm
 * @param name
 * @param libs
 * @returns {*[]}
 */
export function getVueComponentsByName(vm, name, libs = []) {
  vm?.$children?.forEach?.(child => {
    if (child.$options.name === name) {
      libs.push(child)
    }
    if (child?.$children?.length) getVueComponentsByName(child, name, libs)
  })
  return libs
}

export const sleep = timeountMS =>
  new Promise(resolve => {
    setTimeout(resolve, timeountMS)
  })

/**
 * 判断oss文件是否过期
 * @param url
 * @param expireSecond
 * @returns {boolean}
 */
export function isExpiredOssUrl(url, expireSecond = 60) {
  if (typeof url !== 'string') return false
  try {
    const parsedUrl = new URL(url)
    const Expires = +parsedUrl.searchParams.get('Expires')
    if (Expires) {
      return Expires - Date.now() / 1000 < expireSecond
    }
    console.log(Expires)
  } catch (e) {
    console.log(e)
    return false
  }
}

// 上报大数据响应体接口
export function logBigResponse(response) {
  try {
    const contentLength = +response.headers?.['content-length']
    const traceid = response?.headers?.traceid
    const url = response?.config?.url
    if (contentLength > 50 * 1000) {
      window.lib &&
        window.lib?.track?.error?.('接口响应体数据体量超过50k', {
          message: {
            traceid,
            url,
            contentLength
          },
          type: 'big-response-error'
        })
    }
  } catch (e) {
    console.warn(e)
  }
}

/**
 * 解析同步小结单单点同步 埋点方法
 * @param {*} params [{key:'xxx',value:'xx'}]
 */
export function analyticSynchronization(list = [], extend = {}) {
  try {
    list?.forEach?.(item => {
      const { label, value } = item
      if (label === '运单号') {
        libTrack.tap('Document_positioning', 'Document_positioning', {
          pageName: 'zaixiangongzuotai',
          Synchronize_document_types: SYNCHRONIZE_DOCUMENT_TYPES.codes.BUSINESSNO,
          Document_ID: value,
          ...extend
        })
      } else if (label === '投诉单号') {
        libTrack.tap('Document_positioning', 'Document_positioning', {
          pageName: 'zaixiangongzuotai',
          Synchronize_document_types: SYNCHRONIZE_DOCUMENT_TYPES.codes.COMPLAINCASENO,
          Document_ID: value,
          ...extend
        })
      }
    })
  } catch (error) {
    console.info(error, '解析埋点参数异常')
  }
}

/**
 * 解析sop小结单同步 埋点方法
 * @param {*} params {122_$$_caseId:'xxx',...}
 */
export function analyticSOPSynchronization(data = {}, extend = {}) {
  console.log(data, extend, 'analyticSOPSynchronization')
  try {
    if (!Object.keys(data)?.length) return
    Object.keys(data)?.forEach?.(key => {
      const params = {
        pageName: 'zaixiangongzuotai',
        Document_ID: data?.[key],
        ...extend
      }
      if (key.includes('businessNo')) {
        params.Synchronize_document_types = SYNCHRONIZE_DOCUMENT_TYPES.codes.BUSINESSNO
        libTrack.tap('Document_positioning', 'Document_positioning', params)
      } else if (key.includes('complainCaseNo')) {
        params.Synchronize_document_types = SYNCHRONIZE_DOCUMENT_TYPES.codes.COMPLAINCASENO
        libTrack.tap('Document_positioning', 'Document_positioning', params)
      } else if (key.includes('cargoId')) {
        params.Synchronize_document_types = SYNCHRONIZE_DOCUMENT_TYPES.codes.CARGOID
        libTrack.tap('Document_positioning', 'Document_positioning', params)
      }
    })
    libTrack.tap('Document_positioning', 'Document_positioning', {
      pageName: 'zaixiangongzuotai',
      Synchronize_document_types: SYNCHRONIZE_DOCUMENT_TYPES.codes.OTHER,
      Document_ID: JSON.stringify(data),
      ...extend
    })
  } catch (error) {
    console.info(error, '解析埋点参数异常')
  }
}

const ignoreErrorMsgList = [
  'SDK:未登录，不可以退出',
  'SDK:满意度调查失败no channel',
  'SDK:天润置忙失败当前坐席不是空闲中',
  'SDK:通话中，不可以退出',
  'SDK:坐席状态通话中，无法切换',
  'SDK:满意度调查失败，session不存在或已经销毁',
  '当前运行的SOP流程已达到最大数量，无法再启用新的流程',
  '会话转接中，请勿重复操作',
  '取消保存并升级操作',
  '用户有会话在进行或休眠,客服建立会话失败',
  '会话转接中，请勿重复操作'
]
/**
 * 忽略接口业务报错信息
 * @param stack
 * @param fn
 */
export function ignoreTraceErrorToHubble(stack, fn) {
  // 接口类过滤
  if (stack?.response) {
    // 会话已失效，请重新登录
    if (stack?.response?.status === 401) return
    const getter = stack?.response?.config?.getter
    const errorMsg = stack?.response?.data?.[getter.message || 'errorMsg']
    if (stack?.response?.status === 200 && errorMsg && ignoreErrorMsgList.includes(errorMsg)) return
  } else if (typeof stack?.message === 'string' || typeof stack === 'string') {
    // 忽略不影响业务的报错提示
    if (ignoreErrorMsgList.includes(stack?.message)) return
  }
  if (typeof fn === 'function') fn()
}

/**
 * 下载图片（防内存泄漏）
 */
export function downloadImg(src, filename) {
  // 把图片转成base64
  function getBase64Image(img) {
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, img.width, img.height)
    const ext = src
      .substring(src.lastIndexOf('.') + 1)
      .toLowerCase()
      .replace(/;.*$/, '') // 改进扩展名提取
    return canvas.toDataURL('image/' + (ext || 'png')) // 默认使用png格式
  }

  let image = new Image()
  image.crossOrigin = '' // 确保可以跨域
  image.src = src

  image.onload = function() {
    const base64 = getBase64Image(image)

    // 创建下载链接元素
    let save_link = document.createElement('a')
    save_link.href = base64
    save_link.download = filename || 'image.png' // 默认文件名为image.png

    // 一次性事件，执行后移除事件监听
    save_link.onclick = function(event) {
      document.body.appendChild(save_link)
      save_link.click()
      document.body.removeChild(save_link)
      // 清除引用
      save_link = null
      image = null // 确保image也可以被垃圾回收
    }

    // 创建一个鼠标点击事件
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
      // 其他选项...
    })

    // 将事件触发到特定元素上
    save_link.dispatchEvent(event)
  }

  // 监听错误事件，确保加载失败时也能清理资源
  image.onerror = function() {
    // 清除引用
    image = null
  }
}

export function refreshWindowAndClearMemory() {
  window.open(window.location.href, '_blank')
  // 重开式打开页面，绝对清除内存占用
  if (navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
    window.location.href = 'about:blank'
    window.close()
  } else {
    window.opener = null
    window.open('', '_self')
    window.close()
  }
}

export function getUserI18n() {
  return JSON.stringify({
    language: getLanguage(),
    zoneId: getTimeZoneId(),
    country: getCountry()
  })
}

export const getTimeZoneId = () => {
  const commandInfo = getLocal(LOCALE_STORE_KEY)
  let zoneId
  if (commandInfo) {
    zoneId = commandInfo.timeZone
  }
  return zoneId || 'Europe/Istanbul'
}

export const getCountry = () => {
  const commandInfo = getLocal(LOCALE_STORE_KEY)
  let country
  if (commandInfo) {
    country = commandInfo.country
  }
  return country || 'TR'
}

export const getLanguage = () => {
  const commandInfo = getLocal(LOCALE_STORE_KEY)
  let lang
  if (commandInfo) {
    lang = commandInfo.lang
  }
  return lang || 'en-US'
}

export const uploadInWeb = async res => {
  const tempFiles = res.tempFiles

  const tokens = await handlePreUploadInWeb(tempFiles)
  await Promise.all(
    tokens.map((token, index) => {
      const temp = res.tempFiles[index]
      const fileObject = temp.originalFileObj || temp.path || temp.tempFilePath

      return execUploadAsync({
        token,
        file: fileObject
      })
    })
  ).catch(error => {
    console.log('upload error', error)
    setTimeout(() => {
      // Taro.showToast({
      //   // @ts-ignore
      //   context,
      //   icon: 'none',
      //   title: '上传失败',
      // })
    }, 200)
  })
  let temp = tokens.map(item => ({
    key: item.key,
    bizType: item.bizType,
    country: 'TR'
  }))
  let result = await getAbsoluteFile(temp)
  console.log(773, result)
  return result
}

const handlePreUploadInWeb = async tempFile => {
  // const fileList = tempFiles.map(temp => {
  //   const name = temp.originalFileObj?.name || temp.path || temp.tempFilePath || '.jpg'
  //   const ext = resolveFileExtension(name)

  //   return { suffix: ext }
  // })

  const file = {
    suffix: resolveFileExtension(getFileName(tempFile.name, tempFile.type))
  }
  console.log(file, tempFile, 'filefilefile22222222222')

  const { signedUrlList } = await request(`/qmove-file-app/file/prepareMultiSignedUrl`, {
    data: {
      bizType: 'user-pri',
      fileList: [file],
      country: 'TR',
      language: 'tr-TR'
    }
  })

  console.log(signedUrlList, 'signedUrlListsignedUrlListsignedUrlListsignedUrlListsignedUrlList')
  return signedUrlList
}

export const resolveFileExtension = url => {
  console.log(url, 'uuuuuuuu')
  if (!url) return ''
  const index = url.lastIndexOf('.')
  if (index === -1) return ''
  let str = url.slice(index + 1)
  const qsIndex = str.indexOf('?')
  if (qsIndex > -1) str = str.slice(0, qsIndex)
  if (str.indexOf('/') > -1) return ''
  return str
}

export const execUploadAsync = async ({ token, file }) => {
  return request(token.signedUrl, {
    method: 'put',
    data: file,
    ignoreError: true,
    headers: {
      'Content-Type': token?.mine || 'application/octet-stream'
    }
  })
}

export const getAbsoluteFile = data =>
  request('/qmove-file-app/file/batchGetAbsoluteUrl', {
    method: 'post',
    needLoading: false,
    data
  })
